var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"modal in billItemSelectListModal\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <span class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"></span>\n          <h4 class=\"modal-title \">选择餐品</h4>\n        </div>\n        <div class=\"listContainer\">\n        </div>\n      </div>\n    </div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/pos/comp/BillItemsSelectModal.handlebars
// module id = 558
// module chunks = 0